import apiFetch from '../../apiFetch'

export default function (token, colonyId) {
  const queryParamsArray = [
    `colonyId=${colonyId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `Entity/GetAllPostalCodes${queryParams}`, method: 'GET', token: token })
}
